@if (objective) {
    <div class="d-flex align-items-center gap-1 objective-code"
         [attr.data-tour]="'objective-type-' + objective!.typeCode">
        @if (showStatusIcon) {
            <span [ngClass]="'status-icon-' + objective!.status.toLowerCase()"
                  [adaptTooltip]="badgeStatus.name"> </span>
        }
        @if (showAssigneeImage) {
            <adapt-link-person [person]="objective!.assigneePerson!"
                               [showImage]="true"
                               [showText]="false"
                               [imageSize]="'xs'"></adapt-link-person>
        }
        <strong class="objective-type text-nowrap"
                [adaptTooltip]="codeTooltip">
            {{ objective!.objectiveCode }}
        </strong>
        @if (showPrivateTeamIcon) {
            <adapt-team-private-icon [team]="objective.team"></adapt-team-private-icon>
        }
    </div>
    @if (generateHref && (canReadObjective$ | async)) {
        <a [routerLink]="objectiveHref$ | async"
           class="objective-title">{{ objective!.title }}</a>
    } @else {
        <span class="objective-title">{{ objective!.title }}</span>
    }
    @if (showHoverDeleteButton) {
        <button adaptButtonIcon="delete"
                class="btn btn-link delete-button"
                (click)="deleted.emit(objective)"></button>
    }
    @if (showStatus) {
        <adapt-display-objective-status class="ms-auto"
                                        [objectiveStatus]="objective!.status"
                                        [isCompactView]="true"></adapt-display-objective-status>
    }
}
